module.exports = "/img/31.dd9caa.webp";